import Compressor from "compressorjs";

const compressImage = (file, quality = 0.2) => {
  return new Promise((resolve, reject) => {
    new Compressor(file, {
      quality,
      success: result => {
        const isFile = result instanceof File;
        const isBolb = result instanceof Blob;
        if (isFile) {
          resolve(result);
        } else if (isBolb) {
          const compressedFile = new File([result], file?.name)
          resolve(compressedFile);
        } else {
          reject();
        }
      },
      error: err => {
        reject(err);
      },
    });
  });
};

export default compressImage;
